export const menuItems = [
  {
    id: 1,
    label: 'menuitems.menu.text',
    isTitle: true,
    perm: 'menu.dashboard' // Se tem acesso ao dashboard, mostra o título
  },
  {
    id: 2,
    label: 'menuitems.dashboards.text',
    icon: 'bx bx-home-circle',
    link: '/',
    perm: 'menu.dashboard'
  },
  {
    id: 50,
    label: 'Dashboard',
    icon: 'bx bx-bar-chart-alt-2',
    link: '/dashboard',
    perm: 'menu.event_dashboard'
  },
  {
    id: 999,
    label: 'menuitems.analytics.text',
    icon: 'bx bx-pie-chart-alt-2',
    link: '/analytics/sources',
    perm: 'analytics.view'
  },
  {
    id: 3,
    label: 'menuitems.admin.text',
    icon: 'mdi mdi-account-supervisor-circle',
    perm: 'menu.admin',
    subItems: [
      {
        id: 4,
        label: 'menuitems.admin.list.users',
        link: '/admin/users',
        parentId: 3,
        perm: 'admin.users.view'
      }
      // {
      //   id: 5,
      //   label: 'menuitems.admin.list.perms',
      //   link: '/admin/roles',
      //   parentId: 3
      // }
    ]
  },
  {
    id: 6,
    label: 'menuitems.settings.text',
    isTitle: true,
    perm: 'menu.settings'
  },
  {
    id: 7,
    label: 'menuitems.setting.text',
    icon: 'mdi mdi-cog',
    perm: 'menu.settings',
    subItems: [
      {
        id: 8,
        label: 'menuitems.setting.list.event',
        link: '/settings/event',
        parentId: 7,
        perm: 'settings.event'
      },
      {
        id: 9,
        label: 'menuitems.setting.list.rsvp',
        link: '/settings/rsvp',
        parentId: 7,
        perm: 'settings.general'
      },
      {
        id: 65,
        label: 'menuitems.setting.list.financialControl',
        link: '/settings/financial-control',
        parentId: 7,
        perm: 'financial_control.config'
      },
      {
        id: 28,
        label: 'menuitems.setting.list.wa',
        link: '/settings/wa',
        parentId: 7,
        perm: 'settings.integrations'
      },
      {
        id: 52,
        label: 'Templates WhatsApp',
        link: '/wa/template',
        parentId: 7,
        perm: 'settings.integrations'
      },
      {
        id: 10,
        label: 'menuitems.setting.list.site',
        link: '/settings/site',
        parentId: 7,
        perm: 'settings.general'
      },
      {
        id: 12,
        label: 'menuitems.setting.list.email',
        link: '/settings/emails',
        perm: 'settings.integrations',
        parentId: 7
      },
      {
        id: 54,
        label: 'menuitems.setting.list.emailSuppressions',
        link: '/settings/email-suppressions',
        perm: 'settings.integrations',
        parentId: 7
      },
      {
        id: 36,
        label: 'menuitems.setting.list.formBuilder',
        link: '/form-builder',
        perm: 'settings.general',
        parentId: 7
      },
      {
        id: 47,
        label: 'menuitems.setting.list.followUpRules',
        link: '/settings/follow-up-rules',
        perm: 'settings.general',
        parentId: 7
      },
      {
        id: 37,
        label: 'menuitems.setting.list.participantCards',
        link: '/participant-card-builder',
        perm: 'settings.general',
        parentId: 7
      },
      {
        id: 40,
        label: 'menuitems.setting.list.badgeBuilder',
        link: '/badge-builder',
        perm: 'settings.general',
        parentId: 7
      },
      {
        id: 13,
        label: 'menuitems.setting.list.checkin',
        link: '/settings/checkin',
        perm: 'settings.general',
        parentId: 7
      },
      {
        id: 15,
        label: 'menuitems.setting.list.integration',
        link: '/settings/data-integrations',
        perm: 'settings.integrations',
        parentId: 7
      },
      {
        id: 99,
        label: 'Trilha presencial',
        link: '/settings/trilha-presencial',
        perm: 'settings.general',
        parentId: 7
      },
      {
        id: 31,
        label: 'menuitems.setting.list.tasks',
        link: '/settings/tasks',
        perm: 'settings.general',
        parentId: 7
      },
      {
        id: 53,
        label: 'menuitems.setting.list.flightBlocks',
        link: '/settings/flight-blocks',
        perm: 'settings.general',
        requiresLogistics: true,
        parentId: 7
      },
      {
        id: 29,
        label: 'menuitems.setting.list.reports',
        link: '/settings/reports',
        perm: 'settings.general',
        parentId: 7
      },
      {
        id: 35,
        label: 'menuitems.setting.list.filters',
        link: '/settings/filters',
        perm: 'settings.general',
        parentId: 7
      }
    ]
  },
  {
    id: 38,
    label: 'menuitems.boxoffice.text',
    icon: 'bx bx-credit-card',
    perm: 'menu.payments',
    requiresPayment: true, // Só mostra se has_payment = true
    subItems: [
      {
        id: 39,
        label: 'menuitems.boxoffice.list.dashboard',
        link: '/payments/dashboard',
        parentId: 38,
        perm: 'payments.view'
      },
      {
        id: 43,
        label: 'menuitems.boxoffice.list.tickets',
        link: '/payments/tickets',
        parentId: 38,
        perm: 'payments.view'
      },
      {
        id: 44,
        label: 'menuitems.boxoffice.list.cupons',
        link: '/payments/cupons',
        parentId: 38,
        perm: 'payments.view'
      },
      {
        id: 40,
        label: 'menuitems.boxoffice.list.recipient',
        link: '/payments/recipient',
        parentId: 38,
        perm: 'payments.view'
      },
      {
        id: 41,
        label: 'menuitems.boxoffice.list.gateway',
        link: '/payments/gateway',
        parentId: 38,
        perm: 'payments.view'
      },
      {
        id: 42,
        label: 'menuitems.boxoffice.list.transfers',
        link: '/payments/transfers',
        parentId: 38,
        perm: 'payments.view'
      }
    ]
  },
  {
    id: 16,
    label: 'menuitems.rsvp.text',
    isTitle: true,
    perm: null // Sempre mostra se tiver qualquer menu de RSVP
  },
  {
    id: 33,
    label: 'menuitems.registrationControl.text',
    icon: 'bx bx-list-check',
    link: '/registration-controls',
    perm: 'registration_controls.view',
    requiresRegistrationControl: true
  },
  {
    id: 30,
    label: 'menuitems.ecampaign.text',
    icon: 'bx bx-mail-send',
    link: '/email/campaign',
    perm: 'menu.campaigns'
  },
  {
    id: 51,
    label: 'menuitems.messenger.text',
    icon: 'bx bx-chat',
    link: '/wa/messenger',
    perm: 'menu.campaigns',
    requiresWaMessenger: true
  },
  {
    id: 27,
    label: 'menuitems.campaign.text',
    icon: 'bx bx-paper-plane',
    link: '/wa/campaign',
    perm: 'menu.campaigns'
  },
  {
    id: 48,
    label: 'menuitems.journeys.text',
    icon: 'bx bx-git-branch',
    link: '/journeys',
    perm: 'journeys.view'
  },
  {
    id: 17,
    label: 'menuitems.guests.text',
    icon: 'bx bx-user-pin',
    link: '/guests',
    perm: 'menu.guests'
  },
  {
    id: 18,
    label: 'menuitems.participants.text',
    icon: 'bx bxs-user-detail',
    link: '/participants',
    perm: 'menu.participants'
  },
  {
    id: 49,
    label: 'Carta Pax',
    icon: 'bx bx-file',
    link: '/carta-pax',
    perm: 'settings.general'
  },
  {
    id: 32,
    label: 'menuitems.roomlist.text',
    icon: 'bx bxs-business',
    link: '/roomlist-dash',
    perm: 'menu.housing'
  },
  {
    id: 19,
    label: 'menuitems.check-in.text',
    isTitle: true,
    perm: 'menu.checkin'
  },
  {
    id: 47,
    label: 'menuitems.checkin.dashboard',
    icon: 'bx bxs-dashboard',
    link: '/checkin-dashboard',
    perm: 'menu.reports'
  },
  {
    id: 21,
    label: 'menuitems.checkin.name',
    icon: 'fas fa-qrcode',
    link: '/check-in',
    perm: 'menu.checkin'
  },
  {
    id: 20,
    label: 'menuitems.checkin.statistics',
    icon: 'mdi mdi-apps-box',
    link: '/statistics-checkin',
    perm: 'menu.reports'
  },
  {
    id: 45,
    label: 'menuitems.storage.text',
    icon: 'bx bx-package',
    link: '/storage',
    perm: 'storage.view'
  },
  {
    id: 46,
    label: 'menuitems.storageAdmin.text',
    icon: 'bx bx-history',
    link: '/storage-admin',
    perm: 'storage.manage'
  },
  {
    id: 22,
    label: 'menuitems.organize.text',
    isTitle: true,
    perm: 'menu.settings'
  },
  {
    id: 23,
    label: 'menuitems.seats.text',
    icon: 'mdi mdi-gamepad-circle-outline',
    link: '/seating',
    perm: 'seating.view'
  },
  {
    id: 24,
    label: 'menuitems.report.text',
    isTitle: true,
    perm: 'menu.reports'
  },
  {
    id: 25,
    label: 'menuitems.reports.text',
    icon: 'bx bxs-report',
    link: '/reports',
    perm: 'menu.reports'
  }
]
